/**
 * Expense CRUD — backed by /api/expenses. Supports optional event_id filter.
 */
import { useCrudCollection } from './useCrudCollection';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level so buildListUrl has stable identity across renders
// (inline arrow would re-create each render → infinite loop inside useCrudCollection's useCallback).
const buildExpensesListUrl = (weddingId, eventId) =>
  eventId ? `${API}/expenses/${weddingId}?event_id=${eventId}` : `${API}/expenses/${weddingId}`;

export function useExpenses() {
  const crud = useCrudCollection({
    basePath: 'expenses',
    buildListUrl: buildExpensesListUrl,
  });
  return {
    expenses: crud.items,
    setExpenses: crud.setItems,
    fetchExpenses: crud.fetch,
    createExpense: crud.create,
    updateExpense: crud.update,
    deleteExpense: crud.remove,
  };
}
